// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
window.Rails = Rails;
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

import $ from 'jquery'
import 'select2'
import 'select2/dist/css/select2.css'
import '@fortawesome/fontawesome-free/js/all.js'
import '@fortawesome/fontawesome-free/js/fontawesome.js'

import "../src/view_interaction"

// $(document).ready(function() {
//     $('.js-example-basic-multiple').select2();
// });
document.addEventListener("turbolinks:load", () => {
    $('.js-example-basic-multiple').select2();
  });

$('#mySelect2').select2('data');






Rails.start()
Turbolinks.start()
ActiveStorage.start()

